import addPlanId from "@/utils/addPlanId";
import WebshareApi from "..";
import CountryType from "@/types/CountryType";
import { PlanIdTypeSafe } from "@/types/PlanTypes";

interface IResetDownlaodTokenResponse {
  proxy_list_download_token: string;
}
export const resetDownloadToken = (planId?: PlanIdTypeSafe) =>
  WebshareApi.post<IResetDownlaodTokenResponse>(
    addPlanId("/proxy/config/reset_download_token/", planId)
  );

export const proxyListRefresh = (planId?: PlanIdTypeSafe) =>
  WebshareApi.post(addPlanId("/proxy/list/refresh/", planId));

type CreateIpAuthorizationType = { ip_address: string };

export const createIpAuthorization = (
  params: CreateIpAuthorizationType,
  planId: PlanIdTypeSafe
) =>
  WebshareApi.post(addPlanId(`/proxy/ipauthorization/`, planId), { ...params });

type AllocateUnallocatedCountriesType = { new_countries: CountryType };

export const allocateUnallocatedCountries = (
  params: AllocateUnallocatedCountriesType,
  planId?: PlanIdTypeSafe
) =>
  WebshareApi.post(
    addPlanId("/proxy/config/allocate_unallocated_countries/", planId),
    {
      ...params,
    }
  );

export const patchProxyConfig = <T>(params: T, planId: PlanIdTypeSafe) =>
  WebshareApi.patch<T>(addPlanId("/proxy/config/", planId), {
    ...params,
  });
